import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { orderContext } from '../OrderContext';
import { NumberFormat, DetailsPageHeader } from 'components';


let Amounts = () => {
    let service = useContext(orderContext);


    return (
        <DetailsPageHeader sectionName='Amounts'>
            {service.order.amounts &&
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Shipping</TableCell>
                            <TableCell>Tax</TableCell>
                            <TableCell>Subtotal</TableCell>
                            <TableCell>Total</TableCell>
                            <TableCell>Vat erp code</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>
                                <NumberFormat amount={service.order.amounts.shipping} suffix={service.order.currency} decimalScale={5} />
                            </TableCell>
                            <TableCell>
                                <NumberFormat amount={service.order.amounts.tax} suffix={service.order.currency} decimalScale={5} />
                            </TableCell>
                            <TableCell>
                                <NumberFormat amount={service.order.amounts.subtotal} suffix={service.order.currency} decimalScale={5} />
                            </TableCell>
                            <TableCell>
                                <NumberFormat amount={service.order.amounts.total} suffix={service.order.currency} decimalScale={5} />
                            </TableCell>
                            <TableCell>
                                {service.order.amounts.vatErpCode}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            }
        </DetailsPageHeader>
    );
}

export default Amounts;